export function sendAnalyticsEvent(eventName, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
    console.log("GA Event Sent:", eventName, params);
  } else {
    console.warn("gtag not ready yet");
  }
}
